import React from 'react';
import { calendarAPI, meetingsAPI } from '../../services/api';
import GoogleCalendarSection from '../../components/UI/GoogleCalendarSection';
import GoogleMeetSection from '../../components/UI/GoogleMeetSection';

/**
 * Settings → Calendar tab
 * Synchronizes CRM follow-ups and scheduled activities with Google Calendar:
 * the org's Google Calendar is embedded directly in this section, and a
 * private feed URL keeps CRM follow-ups/tasks flowing into Google.
 */
const CalendarTab = () => {
  return (
    <div className="space-y-4">
      {/* Feature description card */}
      <div className="flex items-start gap-3 p-4 rounded-xl bg-blue-50 border border-blue-100">
        <div className="w-9 h-9 rounded-lg bg-blue-600 flex items-center justify-center flex-shrink-0">
          <span className="text-white text-lg">📅</span>
        </div>
        <div>
          <h3 className="text-sm font-semibold text-gray-900">Calendar</h3>
          <p className="text-sm text-gray-600 mt-0.5">
            Synchronizes CRM follow-ups and scheduled activities with Google Calendar. Connect your
            Google Calendar below to display it here, and add the private feed URL so your CRM
            follow-ups and tasks appear in Google Calendar automatically.
          </p>
        </div>
      </div>

      <GoogleCalendarSection
        scope="org"
        fetchSettings={async () => {
          const response = await calendarAPI.getSettings();
          return response?.data?.data || {};
        }}
        saveSettings={(googleCalendarId) => calendarAPI.updateSettings(googleCalendarId)}
      />

      <GoogleMeetSection
        scope="org"
        listMeetings={(params) => meetingsAPI.list(params)}
        createMeeting={(body) => meetingsAPI.create(body)}
        updateMeeting={(id, body) => meetingsAPI.update(id, body)}
      />
    </div>
  );
};

export default CalendarTab;